import { render, staticRenderFns } from "./PricingList.vue?vue&type=template&id=32986ca6&"
import script from "./PricingList.vue?vue&type=script&lang=js&"
export * from "./PricingList.vue?vue&type=script&lang=js&"
import style0 from "./PricingList.vue?vue&type=style&index=0&id=32986ca6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports